import { render, staticRenderFns } from "./InvoiceTab.vue?vue&type=template&id=4d5dd85a"
import script from "./InvoiceTab.vue?vue&type=script&lang=js"
export * from "./InvoiceTab.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTab.vue?vue&type=style&index=0&id=4d5dd85a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports